<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <b-button variant="secondary" class="ml-2" @click="$router.go(-1)">
        <i class="fas fa-arrow-left"></i> {{$t('volver')}}
      </b-button>
      <b-card-header class="border-0">
        <h3 class="mb-0"> {{ $t('nueva_planta') }}</h3>
      </b-card-header>
      <b-form @submit.prevent="submitForm">
        <b-row>
          <b-col md="2">
            <b-form-group label-for="Nombre">
              <template v-slot:label>
                {{ $t('nombre') }} <span class="text-danger">*</span>
              </template>
              <b-form-input id="nombre" v-model="form.nombre" required :placeholder="$t('ingrese_nombre')"></b-form-input>
            </b-form-group>
            <b-form-group>
              <template v-slot:label>
                {{ $t('direccion') }} <span class="text-danger">*</span>
              </template>
              <b-form-input id="nombre" v-model="form.direccion" required
              :placeholder="$t('ingrese_direccion')"></b-form-input>
            </b-form-group>

          </b-col>

          <b-col md="2">
            <b-form-group>
              <template v-slot:label>
                {{ $t('pais') }} <span class="text-danger">*</span>
              </template>
              <b-form-select id="paisID" v-model="form.paisID" @change="onPaisChange" required>
                <option :value="null" disabled> {{ $t('seleccione_opcion') }}</option>
                <option v-for="option in paisOptions" :key="option.value" :value="option.value">
                  {{ option.text }}
                </option>
              </b-form-select>
            </b-form-group>

            <b-form-group label="Empresa" label-for="empresaID">
              <template v-slot:label>
                {{ $t('empresa') }}
              </template>
              <b-form-select id="empresaID" :disabled="!isPaisSelected" v-model="form.empresaID">
                <option :value="null" disabled>{{ $t('seleccione_opcion') }}</option>
                <option v-for="option in empresaOptions" :key="option.value" :value="option.value">
                  {{ option.text }}
                </option>
              </b-form-select>
            </b-form-group>
          </b-col>

          <b-col md="2">

            <b-form-group label="Empresa" label-for="regionID">
              <template v-slot:label>
                {{ $t('region') }} <span class="text-danger">*</span>
              </template>
              <b-form-select id="empresaID" :disabled="!isPaisSelected" v-model="form.regionID" required @change="onRegionChange">
                <option :value="null" disabled>{{ $t('seleccione_opcion') }}</option>
                <option v-for="option in regionOptions" :key="option.value" :value="option.value">
                  {{ option.text }}
                </option>
              </b-form-select>
            </b-form-group>

            <b-form-group label="Empresa" label-for="ciudadID">
              <template v-slot:label>
                {{ $t('ciudad') }} <span class="text-danger">*</span>
              </template>
              <b-form-select id="ciudadID" :disabled="!isRegionSelected" v-model="form.ciudadID" required>
                <option :value="null" disabled>{{ $t('seleccione_opcion') }}</option>
                <option v-for="option in ciudadOptions" :key="option.value" :value="option.value">
                  {{ option.text }}
                </option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <b-button type="submit" variant="primary">
          {{ $t('guardar') }}
        </b-button>
      </b-form>
    </base-header>
  </div>
</template>
<script>
import plantaService from '@/api/plantaService';
import miscService from '@/api/miscService';
export default {
  data() {
    return {
      form: {
        nombre: '',
        direccion: '',
        empresaID: null,
        regionID: null,
        paisID: null,
        ciudadID: null
      },
      empresaOptions: [],
      paisOptions: [],
      ciudadOptions: [],
      regionOptions: [],
      passwordError: '',
      isPaisSelected: false,
      isRegionSelected: false
    };
  },
  async beforeMount() {
    this.paisOptions = await miscService.getPaisesOptions();
  },
  methods: {
    async onPaisChange() {
      const pais = this.form.paisID;
      this.form.empresaID = null;
      this.form.regionID = null;
      this.form.ciudadID = null;
      if (pais) {
        this.empresaOptions = await miscService.getEmpresasByPaisOptions(pais);
        this.regionOptions = await miscService.getRegionesOptions(pais);
        this.isPaisSelected = true;
      } else {
        this.empresaOptions = [];
        this.regionOptions = [];
        this.isPaisSelected = false;
      }
    },
    async onRegionChange() {
      const region = this.form.regionID;
      this.form.ciudadID = null;
      if (region) {
        this.ciudadOptions = await miscService.getCiudadesOptions(region);
        this.isRegionSelected = true;
      } else {
        this.ciudadOptions = [];
        this.isRegionSelected = false;
      }
    },
    async submitForm() {
      try {
        const response = await plantaService.create(this.form);
        if (!response) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: 'Ocurrió un error al crear la planta, intente nuevamente.'
          });
          return;
        }

        Swal.fire({
          title: "Creado correctamente",
          icon: "success",
          showConfirmButton: false,
          timer: 2000,
          background: '#f8f9fa',
          customClass: {
            title: 'swal-title',
            icon: 'swal-icon',
          },
        });
        this.$router.push(`/plantas/details/${response.plantaID}`);
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message
        });
      }
    },
    validatePassword() {
      if (this.form.password.length < 5) {
        this.passwordError = 'La contraseña debe contener al menos 5 caracteres.';
      } else {
        this.passwordError = '';
      }
    }

  },
};
</script>
<style>
.el-table.table-dark {
  background-color: #4d4c4c;
  color: #f8f9fe;
}

.el-table.table-dark th,
.el-table.table-dark tr {
  background-color: #4d4c4c;
}

.el-table.table-dark td,
.el-table.table-dark th.is-leaf {
  border-bottom: none;
}
</style>
